module.exports = __webpack_public_path__ + "static/media/bg_watercolor_blue_transparent.22303c6a.png";